import _ from 'lodash';
import React from 'react';
import Loading from '../../../../shared/loading';
import mutate from '../../../../shared/mutate';
import ErrorBoundary from '../../../../shared/error-boundary';
import defaultOnErrorHandler from '../../../../shared/default-on-error-handler';
import EditSeriesModal from './edit-series-modal';
import { getAllSeries } from '../../../../services/lwadmin/series/series-service';

export default class SeriesTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      /* eslint-disable react/no-unused-state */
      allSeries: [],
      series: [],
      archivedFilter: true,
      /* eslint-ensable react/no-unused-state */
    };
  }

  componentDidMount() {
    this.refresh();
  }

  handleFilterOutArchivedSeriesChange(e) {
    const archivedFilter = !e.target.checked;

    this.setState(oldState => mutate(oldState, state => {
      state.archivedFilter = archivedFilter;
      state.series = this.filterSeries(state.allSeries, state);
    }));
  }

  refresh() {
    this.loading.start();
    getAllSeries()
      .then(result => this.setState(oldState => mutate(oldState, state => {
        state.allSeries = _.map(result.data.series, s => _.pick(s, [
          'id', 'title', 'slug', 'description', 'archived',
        ]));
        state.series = this.filterSeries(state.allSeries, state);
      })))
      .catch(e => defaultOnErrorHandler(e, 'Error loading series'))
      .finally(() => this.loading.stop());
  }

  editSeries(e, series) {
    e && e.preventDefault && e.preventDefault();

    this.editSeriesModal.present(series.id);
  }

  // eslint-disable-next-line class-methods-use-this
  filterSeries(series, state) {
    let filteredSeries = _(series);
    filteredSeries = filteredSeries.filter(x => !state.archivedFilter || !x.archived);
    return filteredSeries.value();
  }

  render() {
    return (
      <ErrorBoundary>
        <h1>Series</h1>
        <p className="form-group">
          <label htmlFor="include-archived">
            <input
              id="include-archived"
              type="checkbox"
              checked={!this.state.archivedFilter}
              onChange={e => this.handleFilterOutArchivedSeriesChange(e)}
            />
            Include archived collections
          </label>
        </p>
        <div className="lwadmin-series-table">
          <Loading ref={el => (this.loading = el)}>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Slug</th>
                  <th>Description</th>
                  <th>Visible</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.series.map(series => (
                  <tr key={series.id}>
                    <td>{series.title}</td>
                    <td>{series.slug}</td>
                    <td>{series.description}</td>
                    <td>{series.archived ? 'No' : 'Yes'}</td>
                    <td className="table-tools">
                      <a href="#" onClick={e => this.editSeries(e, series)}>Edit</a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Loading>
          <EditSeriesModal
            ref={el => (this.editSeriesModal = el)}
            seriesDidSave={() => this.refresh()}
          />
        </div>
      </ErrorBoundary>
    );
  }
}
